export const breakpoints = {
  mobile: '(max-width:767px)',
  tablet: '(min-width: 768px)',
  desktop: '(min-width: 1024px)',
};
